<template>
  <div class="container">
    <div class="row">
      <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="ui-block">
          <div class="top-header top-header-favorit pt-4">
            <div class="top-header-thumb">
              <img :src="headerPhoto" alt="nature" class="header-img fit_cover" />
              <div class="img-overlay"></div>
              <div class="top-header-author author-content profile-icon">
                <SUserAvatar class="author-thumb d-flex group-avatar fit-contain" :myUser="userProfile" size="x-large"
                  :isProfileAvatar="true" />
                <div class="author-content">
                  <span class="author-name profile-name">{{ getUserName(userProfile) }}</span>
                  <div class="profile-username">(@{{ userProfile.username }})</div>
                </div>
              </div>
            </div>
            <div class="profile-section">
              <div class="d-flex profile-buttons-container">
                <div class="col col-xl-8 m-auto col-lg-8  profile-buttons">
                  <div class="about-me" v-if="showProfile">
                    <ProfileAboutMe :about="userProfile" />
                   </div>
                  <ul class="header-buttons-list">
                    <li>
                      <router-link
                        :to="{ name: 'InventoryItems' }"
                        :class="{ 'highlight-menu': menuOption === 0 }"

                        data-cy="profileItemsBtn"
                      >
                        <span>Inventory</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'ProfileGroups' }"
                        :class="{ 'highlight-menu': menuOption === 1 }"
                        data-cy="profileGroupsBtn"
                      >
                        <span>Groups</span>
                      </router-link>
                    </li>
                    <li v-if="userProfile.id === loggedUser.id">
                      <router-link
                        :to="{ name: 'ProfileSettings' }"
                        :class="{ 'highlight-menu': menuOption === 2 }"
                        data-cy="profileSettingsBtn"
                      >
                        <span>Settings</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import ItemHelperVue from "../../mixins/ItemHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import ProfileAboutMe from '../molecules/ProfileAboutMe.vue';
import Global from "@/constants/Global";

export default {
  name: "HeaderInventory",
  props: ["userProfile"],
  mixins: [UserHelperVue, ChatHelperVue, ItemHelperVue],
  data() {
    return {
      isOpen: false,
      idModal: "",
      auxReloadProfilePic: 0,
      auxReloadHeaderPic: 0,
      showProfile: false
    };
  },
  components: {
    SUserAvatar,
    ProfileAboutMe
  },
  computed: {
    headerPhoto() {
      let photo = this.getUserHeaderProfileImg(this.userProfile.id);
      photo = `${photo}?t=${this.auxReloadHeaderPic}`;
      if (photo) return photo;
      return "/img/new-profile-header.png";
    },
    profilePhoto() {
      const url = this.getUserImagePath(this.userProfile);
      return `${url}?t=${this.auxReloadProfilePic}`;
    },
    messages() {
      if (this.userMessages.length > 0) {
        return this.userMessages.find((item) => {
          return item.id == this.$route.params.id;
        });
      }
      return false;
    },
    menuOption() {
      if (this.$route.name === "ProfileSettings") {
        return 2;
      } else if (this.$route.name === "ProfileGroups") {
        return 1;
      } else {
        return 0;
      }
    },
  },
  methods: {
    handleResize() {
      this.showProfile = window.innerWidth < 1024;
    },
    setTab() {
      if (this.$route.name === "ProfileSettings") {
        this.$emit("selectedTab", 2);
      } else if (this.$route.name === "ProfileGroups") {
        this.$emit("selectedTab", 1);
      } else {
        this.$emit("selectedTab", 0);
      }
    },
    removePhoto () {
      this.removeProfilePhoto(this.loggedUser.id)
      location.reload();
    },
    openShareModal() {
      $("#share-inventory-modal").modal("show");
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.shareLink);
    },
    async setChat() {
      if (!this.messages) {
        let firstTimeChat = {
          firstName: this.userProfile.firstName,
          id: this.userProfile.id,
          username: this.userProfile.username,
          messages: [],
          firstTalk: true,
        };
        await this.setPopupChat({
          isOpen: this.isOpen,
          chatMsgs: firstTimeChat,
        });
      } else {
        await this.setPopupChat({
          isOpen: this.isOpen,
          chatMsgs: this.messages,
        });
      }
      this.isOpen = !this.isOpen;
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup(
        this.userProfile.id
      );
    },
    reloadHeaderPhoto() {
      this.auxReloadHeaderPic++;
    },
    reloadProfilePhoto() {
      this.$parent.$parent.$children[0].$refs.headerUserProfile.reloadUserHeaderImg();
      this.auxReloadProfilePic++;
    }
  },
  mounted() {
    this.showProfile = window.innerWidth < 1024;
    window.addEventListener('resize', this.handleResize);
    this.shareLink = Global.getFrontDomain() + "/" + this.user.username + "/inventory";
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.ui-block {
  background-color: transparent !important;
  border: unset !important;
  margin-bottom: 25px;
}
.container {
  padding: 0 64px !important;
  max-width: 1628px;
}
.profile-name {
  font-size: 36px;
  margin: unset;
}
.profile-username {
  font-size: 16px;
  margin-top: 10px;
}
.profile-buttons {
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
  flex-direction: column;
  min-width: calc(100% - 24px);
}
.share-button-desktop {
  width: 50%;
  display: flex;
  margin: auto;
  bottom: 15px;
}
.profile-buttons-container {
  justify-content: space-between;
}
.profile-buttons-container::before {
  background-color: #939393;
  position: absolute;
  bottom: 15px;
  content: "";
  height: 1px;
  width: 100%;
  z-index: 0;
}

.header-img {
  max-width: 1268px;
}

.img-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 4.44%;
  top: 0;
  bottom: 56.25%;
  background: rgba(0, 0, 0, 0.62);
  border-radius: 3.69871px 3.69871px 0px 0px;
}

.top-header-author .author-content {
  margin-left: 0 !important;
}

.picture-settings {
  background-color: white;
  border: 1px solid black;
  margin: unset;
  width: 35px;
  height: 35px;
}

.olymp-settings-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
}

.more-dropdown {
  right: -38px;
}

.more-with-triangle.triangle-bottom-right:before {
  right: 44px;
}

.control-block-button {
  bottom: 5px;
  left: 122px;
  z-index: 5;
  cursor: pointer;
}

.profile-section {
  display: flex;
  flex-direction: column-reverse;
  padding: unset;
  margin: 24px 0 24px 240px;
  z-index: 5;
}

.profile-section.header-buttons-container {
  position: absolute;
  bottom: -32px;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  width: 100%;
}

.top-header-author .author-thumb {
  width: 160px;
  height: 160px;
}

.header-buttons-list {
  padding-bottom: 7px;
  display: flex;
  justify-content: left;
  border-bottom: 1px solid lightgray;
  width: 74%;
}

.header-buttons-list li {
  margin-right: 40px;
  font-weight: 700;
}

.highlight-menu {
  padding-bottom: 8px;
  font-weight: bold;
  border-bottom: 2px solid #05919b;
  color: #05919b !important;
  width: 100%;
}

.header-buttons-list li a {
  color: unset;
}

.about-me{
  background-color: #fff;
  border-radius: 5px;
  min-width: 100%;
}
.share-button {
  width: 50%;
  display: flex;
  margin: auto;
}
.share-input-design {
  display: flex;
  align-items: center;
  border: 1px solid gray;
  border-radius: 10px;
}
.share-input {
  border: none;
}
.copy-button {
  width: 15%;
  cursor: pointer;
  color: #05919B;
}

@media (max-width: 1200px) {
  .top-header.top-header-favorit .top-header-author {
    bottom: -40px !important;
  }
  .profile-buttons-container {
    margin: unset;
  }
  .profile-buttons-container::before {
    bottom: 13px;
  }
}

@media (max-width: 1023px) {

  .profile-name {
    font-size: 24px;
  }
  .container {
    padding: 0 !important;
    max-width: 100%;
  }
  .profile-username {
    margin-bottom: -16px;
  }
  .top-header.top-header-favorit .top-header-author {
    bottom: -26px !important;
  }
  .top-header.top-header-favorit .author-content {
    margin-top: -40px;
  }
  .fit-contain {
    max-width: 88px;
    max-height: 88px;
  }.control-block-button {
    left: 68px;
  }
  .profile-section {
    margin: 40px 72px 20px;
  }
  .profile-buttons-container, .profile-buttons-container ul {
    width: 100%;
  }
  .header-buttons-list {
    justify-content: space-around;
  }
}
@media (max-width: 720px) {
  .profile-section {
    margin: 40px 8px 20px;
  }
}
@media (max-width: 460px) {
  .profile-name {
    font-size: 24px;
  }
  .profile-username {
    margin-top: 0px;
  }
  .profile-icon {
    bottom: 0 !important ;
    top: auto !important;
  }
  .top-header.top-header-favorit .top-header-author .author-thumb {
    width: 74px !important;
    height: 74px !important;
  }
  .control-block-button {
    bottom: -2px;
    left: 45px;
  }
  .share-button {
    width: 100%;
  }
}
</style>
